import { useState } from 'react';
import { Link } from 'wouter';
import { SEOHead } from '../components/SEOHead';
import { ArrowLeft, Home } from 'lucide-react';

export default function AppJobNew() {
  const [address, setAddress] = useState('');
  const [propertyType, setPropertyType] = useState('apartment');

  return (
    <div className="min-h-screen bg-[var(--color-white)]">
      <SEOHead title="Neuer Auftrag – pixcapture.app" description="Auftrag erstellen" path="/app/job-new" />
      
      <header className="border-b border-[var(--color-light-grey)] px-6 py-4">
        <div className="flex items-center gap-4">
          <Link href="/app/jobs">
            <button className="p-2 hover:bg-gray-100 rounded">
              <ArrowLeft className="h-5 w-5" />
            </button>
          </Link>
          <h1 className="text-[20px]">Neuer Auftrag</h1>
        </div>
      </header>

      <main className="p-6 max-w-2xl mx-auto">
        <div className="space-y-6">
          <div>
            <label className="block text-sm mb-2">Adresse</label>
            <div className="relative">
              <Home className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-[var(--color-grey)]" />
              <input
                type="text"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-[var(--color-light-grey)] rounded-md"
                placeholder="Musterstraße 123, Hamburg"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm mb-2">Objekttyp</label>
            <select
              value={propertyType}
              onChange={(e) => setPropertyType(e.target.value)}
              className="w-full px-4 py-3 border border-[var(--color-light-grey)] rounded-md"
            >
              <option value="apartment">Wohnung</option>
              <option value="house">Haus</option>
              <option value="commercial">Gewerbe</option>
            </select>
          </div>

          <button className="w-full py-3 bg-[var(--color-accent)] text-white rounded-md">
            Auftrag erstellen
          </button>
        </div>
      </main>
    </div>
  );
}
